import runtimeContract from '../data/ap-course-runtime.generated.js';

const RUNTIME_COURSE_MAP = Object.fromEntries(runtimeContract.courses.map((course) => [course.slug, course]));

export const MAX_AP_COURSES_PER_STUDENT = runtimeContract.studentCourseLimit;

export const AP_COURSES = [
  ['biology', 'AP Biology', 'Science'],
  ['chemistry', 'AP Chemistry', 'Science'],
  ['environmental-science', 'AP Environmental Science', 'Science'],
  ['physics-1', 'AP Physics 1: Algebra-Based', 'Science'],
  ['physics-2', 'AP Physics 2: Algebra-Based', 'Science'],
  ['physics-c-mechanics', 'AP Physics C: Mechanics', 'Science'],
  ['physics-c-electricity-magnetism', 'AP Physics C: Electricity and Magnetism', 'Science'],
  ['calculus-ab', 'AP Calculus AB', 'Mathematics'],
  ['calculus-bc', 'AP Calculus BC', 'Mathematics'],
  ['precalculus', 'AP Precalculus', 'Mathematics'],
  ['statistics', 'AP Statistics', 'Mathematics'],
  ['psychology', 'AP Psychology', 'Social Science'],
  ['human-geography', 'AP Human Geography', 'Social Science'],
  ['us-government', 'AP United States Government and Politics', 'Social Science'],
  ['comparative-government', 'AP Comparative Government and Politics', 'Social Science'],
  ['macroeconomics', 'AP Macroeconomics', 'Economics'],
  ['microeconomics', 'AP Microeconomics', 'Economics'],
  ['us-history', 'AP United States History', 'History'],
  ['world-history-modern', 'AP World History: Modern', 'History'],
  ['european-history', 'AP European History', 'History'],
  ['english-language', 'AP English Language and Composition', 'English'],
  ['english-literature', 'AP English Literature and Composition', 'English'],
  ['computer-science-a', 'AP Computer Science A', 'Computer Science'],
  ['computer-science-principles', 'AP Computer Science Principles', 'Computer Science'],
  ['seminar', 'AP Seminar', 'AP Capstone'],
  ['research', 'AP Research', 'AP Capstone'],
  ['spanish-language', 'AP Spanish Language and Culture', 'World Languages'],
].map(([slug, title, family]) => ({
  ...RUNTIME_COURSE_MAP[slug],
  slug,
  title,
  shortTitle: title.replace(/^AP\s/, ''),
  family,
  qdrantAlias: `ap_${slug.replaceAll('-', '_')}_current`,
}));

export const AP_COURSE_MAP = Object.fromEntries(AP_COURSES.map((course) => [course.slug, course]));

export const AP_COURSE_FAMILIES = AP_COURSES.reduce((groups, course) => {
  if (!groups[course.family]) groups[course.family] = [];
  groups[course.family].push(course);
  return groups;
}, {});

export function getApCourse(slug) {
  return AP_COURSE_MAP[slug] || null;
}

export function isAvailableApCourse(slug) {
  return Boolean(getApCourse(slug));
}
